import { render, staticRenderFns } from "./Ofta.vue?vue&type=template&id=2374aee6&scoped=true&"
import script from "./Ofta.vue?vue&type=script&lang=js&"
export * from "./Ofta.vue?vue&type=script&lang=js&"
import style0 from "./Ofta.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Ofta.vue?vue&type=style&index=1&id=2374aee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2374aee6",
  null
  
)

export default component.exports